import { DataPercentageContainer, PrincipalImageStatusPercentage, Percentage, ValuePercentage } from './styles'

export function PercentageValues ({ values, dxIA = null }) {
  const toProbability = (rawValue) => {
    const parsedValue = Number(rawValue)
    if (Number.isNaN(parsedValue)) return 0
    return Math.max(0, Math.min(1, parsedValue))
  }

  const obtainValue = () => {
    const normalizedValue = toProbability(values)
    if (dxIA === null) { return normalizedValue } else { return dxIA ? normalizedValue : (1 - normalizedValue) }
  }

  const value = Math.round(obtainValue() * 100)
  return (
    <DataPercentageContainer value={value} dxIA={dxIA}>
      <PrincipalImageStatusPercentage value={value} dxIA={dxIA}>
        <Percentage value={value} dxIA={dxIA} />
      </PrincipalImageStatusPercentage>
      <ValuePercentage> {value}% </ValuePercentage>
    </DataPercentageContainer>
  )
}
